module.exports = Slick;